<!-- Language selector -->
<div class="flex justify-center flex-col text-[24px] cursor-pointer  md:py-6" sag-ui-menu-trigger
     menuTriggerFor="langMenu">
    <span class="icon-region"></span>
</div>
<sag-ui-menu menu="langMenu">
    <sag-ui-menu-item (click)="changeLang('en')">{{ 'header.language.english' | translate }}</sag-ui-menu-item>
    <sag-ui-menu-item (click)="changeLang('de')">{{ 'header.language.german' | translate }}</sag-ui-menu-item>
</sag-ui-menu>

<!-- Theme selector -->
<div class="flex justify-center flex-col text-[24px] cursor-pointer md:py-6" sag-ui-menu-trigger
     menuTriggerFor="settingsMenu">
    <span class="icon-settings"></span>
</div>
<sag-ui-menu menu="settingsMenu">
    <sag-ui-menu-item sag-ui-menu-trigger menuTriggerFor="themeMenu"
                      menuPosition="right">{{ 'header.theme.title' | translate }}
    </sag-ui-menu-item>
    <sag-ui-menu menu="themeMenu">
        <sag-ui-menu-item (click)="setTheme('light')">{{ 'header.theme.light' | translate }}</sag-ui-menu-item>
        <sag-ui-menu-item (click)="setTheme('dark')">{{ 'header.theme.dark' | translate }}</sag-ui-menu-item>
    </sag-ui-menu>
</sag-ui-menu>
@if (!isRouterPathUnauthorized() && authService.isAuthenticated()) {
    <app-user-profile></app-user-profile>
    <sag-ui-button class="ml-auto hidden md:block" (click)="logout()">{{
            'header.logout' | translate
        }}
    </sag-ui-button>
} @else {
    <sag-ui-button class="ml-auto hidden md:block" (click)="login()">{{
            'header.login' | translate
        }}
    </sag-ui-button>
}
